import { MEDIA_TYPE } from 'enums'

/**
 * Generates a unique project name based on the maximum existing index.
 * Note: existingNames is expected to be empty or contain a single string with the highest index.
 * * @param {string} baseName - The target name (e.g., 'test').
 * @param {string[]} existingNames - Array containing either 0 or 1 element (the one with max index).
 * @returns {string} The next available unique name.
 */
export function generateProjectName(baseName, existingNames) {
  // 1. If no names exist, the baseName is unique
  if (!existingNames || existingNames.length === 0) {
    return baseName
  }

  const maxName = existingNames[0]

  // 2. Extract the root from baseName (e.g., "test(10)" -> "test")
  const rootName = baseName.replace(/\(\d+\)$/, '')

  // 3. Escape root for RegExp
  const escapedRoot = rootName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`^${escapedRoot}(?:\\((\\d+)\\))?$`)

  const match = maxName.match(regex)

  if (match) {
    // If the match has a number in brackets, increment it
    if (match[1]) {
      const maxIndex = parseInt(match[1])
      return `${rootName}(${maxIndex + 1})`
    }
    // If it's just the root name without brackets (e.g., "test"), return "test(1)"
    return `${rootName}(1)`
  }

  // 4. Fallback: if existing maxName doesn't match our pattern at all
  return existingNames.includes(baseName) ? `${rootName}(1)` : baseName
}

export function getOutputFormat({ fileType }) {
  if (fileType === MEDIA_TYPE.MXF || fileType === MEDIA_TYPE.TS) {
    return fileType
  }
  return MEDIA_TYPE.MP4
}
